<template>
    <main-loading v-if="isLoading"/>
    <div class="profit-center" v-else>
        <!-- 绑卡组件 -->
        <bindCard
            v-if="isShowBindCard"
            @hideBindCard="isShowBindCard = false"
            :account-info="accountInfo"
        />
        <template v-else>
            <!-- 公告 -->
             <notice
                :type="isBindCard ? '' : 'warning'"
                :content="isBindCard ? noticeText : '您还未绑定银行卡，绑卡后才可进行法律服务经营，为避免影响您在平台的正常经营，请先完成绑卡'"
            />
            <div class="header">
                <div class="title">
                    收益中心
                </div>
                <div class="bind-card" @click="showBindCard">
                    {{ isBindCard ? '我的绑卡信息' : '当前还未绑卡，去绑卡' }}
                    <veui-icon class="bind-card-arrow" name="chevron-right"/>
                </div>
            </div>
            <!-- tab -->
            <div class="tabs">
                <veui-tabs
                    ui="l"
                    :active="curTab"
                    @change="tabChange"
                >
                    <veui-tab
                        label="订单记录"
                        name="orderRecord"
                    />
                    <veui-tab
                        label="打款记录"
                        name="payRecord"
                    />
                </veui-tabs>
                <!-- 日期选择 -->
                <div class="date-wrap" v-if="curTab === 'orderRecord'">
                    <veui-checkbox-group
                        :items="dateOptions"
                        v-model="orderDateType"
                        @change="dateTypeChange"
                    >
                        <template #item="{label}">
                            <div v-if="label !== '日期范围'">
                                {{ label }}
                            </div>
                            <div v-else>
                                <veui-date-picker
                                    range
                                    v-model="dateRange"
                                    overlay-class="syzx-date-picker"
                                    :disabled="!(orderDateType[0] === -1)"
                                    @select="dateChange"
                                />
                            </div>
                        </template>
                    </veui-checkbox-group>
                </div>
                <!-- 月份选择 -->
                <div class="date-wrap" v-else>
                    <veui-checkbox-group
                        :items="monthOptions"
                        v-model="payMonthType"
                        @change="monthTypeChange"
                    >
                        <template #item="{label}">
                            <div v-if="label !== '月份范围'">
                                {{ label }}
                            </div>
                            <div v-else>
                                <veui-date-picker
                                    v-model="monthRange"
                                    type="month"
                                    range
                                    overlay-class="syzx-month-picker"
                                    :disabled="!(payMonthType[0] === -1)"
                                    @select="monthChange"
                                />
                            </div>
                        </template>
                    </veui-checkbox-group>
                </div>
            </div>
            <!-- 订单记录 -->
            <template v-if="curTab === 'orderRecord'">
                <div class="table-top">
                    <div class="export" @click="downloadOrder">
                        <div class="text">下载订单明细</div>
                        <div class="icon"></div>
                    </div>
                </div>
                <div class="table">
                    <veui-table
                        ui="m"
                        align="center"
                        role="columnheader"
                        :data="orderList"
                        :loading="isTableLoading"
                        key="order_table"
                    >
                        <veui-table-column
                            field="date"
                            title="订单时间"
                            width="150"
                        >
                            <template #default="{ date }">
                                {{ date | dateFilter }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="type"
                            title="订单类型"
                            width="150"
                        >
                            <template #default="{ type }">
                                {{ type }}咨询
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="oid"
                            title="订单编号"
                        />
                        <veui-table-column
                            field="price"
                            title="订单金额(元)"
                            width="120"
                        />
                        <veui-table-column
                            field="status"
                            title="订单状态"
                            width="120"
                        />
                        <veui-table-column
                            field="remarks"
                            title="备注"
                        >
                            <template #default="{ remarks }">
                                {{ remarks || '-' }}
                            </template>
                        </veui-table-column>
                    </veui-table>
                    <veui-pagination
                        v-if="orderCount"
                        :page="page"
                        :total="orderCount"
                        :page-size="pageSize"
                        class="pagination"
                        @redirect="pageChange"
                    />
                </div>
            </template>
            <!-- 打款记录 -->
            <template v-else>
                <div class="table-top">
                    <div class="export" @click="downloadPay">
                        <div class="text">下载打款明细</div>
                        <div class="icon"></div>
                    </div>
                </div>
                <div class="table">
                    <veui-table
                        ui="m"
                        align="center"
                        :data="payList"
                        role="columnheader"
                        :loading="isTableLoading"
                        key="pay_table"
                    >
                        <veui-table-column
                            field="date"
                            title="打款日期"
                            width="150"
                        />
                        <veui-table-column
                            field="startDate"
                            title="打款账期"
                            width="150"
                        >
                            <template #default="{startDate, endDate}">
                                {{ startDate | dateFilter('MM/DD') }}-{{ endDate | dateFilter('MM/DD') }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="content"
                            title="打款内容"
                            width="150"
                        >
                             <template #default="{ content }">
                                {{ content }}咨询
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="type"
                            title="打款类型"
                            width="120"
                        />
                        <veui-table-column
                            field="money"
                            title="打款金额(元)"
                            width="150"
                        />
                        <veui-table-column
                            field="status"
                            title="打款进度"
                            width="120"
                        >
                            <template #default="{ status }">
                                {{ status || '-' }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="operation"
                            title="操作"
                            align="center"
                        >
                            <template #default="{ index, status }">
                                <veui-button
                                    ui="text"
                                    class="text-btn"
                                    @click="showDetail(index)"
                                >
                                    查看明细
                                </veui-button>
                                <veui-button
                                    v-if="status === '打款失败'"
                                    ui="text"
                                    class="text-btn"
                                    @click="isShowFeedback = true"
                                >
                                    反馈
                                </veui-button>
                            </template>
                        </veui-table-column>
                    </veui-table>
                    <veui-pagination
                        v-if="payCount"
                        :page="page"
                        :total="payCount"
                        :page-size="pageSize"
                        class="pagination"
                        @redirect="pageChange"
                    />
                </div>
            </template>
        </template>
        <!-- 打款失败弹框 -->
        <confirmDialog
            title="打款失败反馈"
            v-if="isShowFeedback"
            confirm-btn="我知道了"
            :is-show-cancel-btn="false"
            :is-default-content="false"
            :is-show-close-icon="true"
            @confirm="isShowFeedback = false"
            @cancel="isShowFeedback = false"
        >
            <div>当前由于系统错误打款失败，为您带来的不便我们非常抱歉。</div>
            <div>您可通过律临反馈邮箱lvlin_help@baidu.com或您的代理商联系我们进行反馈，申请再次打款。</div>
        </confirmDialog>
        <!-- 账单明细 -->
        <detail
            v-if="isShowDetial"
            :detail-info="detailInfo"
            @closeDetail="isShowDetial=false"
        />
    </div>
</template>

<script>
/**
 * @file index.vue
 * @author dingzhenyue
 * @desc 收益中心
 */
import notice from '../components/notice.vue';
import bindCard from '../components/bindCard.vue';
import 'veui-theme-dls-icons/chevron-right';
import {
    Icon,
    Tabs,
    Tab,
    Table,
    Column,
    Pagination,
    CheckboxGroup,
    DatePicker,
    Button
} from 'veui';
import bendSDK from '@baidu/bend-plugin-sdk';
import MainLoading from '../../../components/law/main-loading.vue';
import confirmDialog from '@/components/confirm-dialog.vue';
import detail from '../components/detail.vue';
import dayjs from 'dayjs';
import {downloadTool} from '@/utils/download';

export default {
    name: 'profitCenter',
    data() {
        return {
            curTab: 'orderRecord', // 当前选中tab
            orderCount: 200, // 订单总数
            payCount: 200, // 打款总数
            orderList: [], // 订单数据
            page: 1,
            pageSize: 10,
            isLoading: true,
            dateOptions: [
                {
                    label: '近7天内',
                    value: 7,
                    exclusive: true
                },
                {
                    label: '近30天内',
                    value: 30,
                    exclusive: true
                },
                {
                    label: '日期范围',
                    value: -1,
                    exclusive: true
                }
            ],
            monthOptions: [
                {

                    label: '近3个月',
                    value: 3,
                    exclusive: true
                },
                {

                    label: '近6个月',
                    value: 6,
                    exclusive: true
                },
                {
                    label: '月份范围',
                    value: -1,
                    exclusive: true
                }
            ],
            monthRange: null, // 月份范围
            isShowBindCard: true, // 是否展示绑定卡片组件
            accountInfo: {},
            isBindCard: false, // 是否绑定银行卡
            isShowFeedback: false, // 是否展示反馈弹框
            isShowDetial: false, // 是否展示账单明细
            orderDateType: [7], // 订单的时间筛选,7,30,-1
            payMonthType: [3], // 打款的月份筛选,3,6,-1
            startDate: '', // 筛选开始日期
            endDate: '', // 筛选结束日期
            dateRange: null, // 日期范围
            startMonth: '', // 打款记录开始月份
            endMonth: '', // 打款记录结束月份
            detailPayMoney: 0, // 打款金额
            detailTaxMoney: 0, // 扣税金额
            detailOrderMoney: 0, // 订单金额
            detailInfo: {},
            isTableLoading: false // 表格加载中
        };
    },
    components: {
        notice,
        'veui-icon': Icon,
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-checkbox-group': CheckboxGroup,
        'veui-date-picker': DatePicker,
        'veui-button': Button,
        bindCard,
        'main-loading': MainLoading,
        confirmDialog,
        detail
    },
    computed: {
        noticeText() {
            let curMonth = new Date().getMonth() + 1;
            return `${curMonth}月收益，将于${curMonth === 12 ? 1 : curMonth + 1}月20日完成打款，届时请注意短信查收～`;
        }
    },
    filters: {
        dateFilter(date, type = 'YYYY/MM/DD') {
            if (!date) {
                return '-';
            }
            return dayjs(date).format(type) || '-';
        }
    },
    beforeCreate() {
        this.$wywLog.addKey({
            page: 'syzx'
        });
    },
    mounted() {
        this.dateTypeChange(this.orderDateType);
        this.monthTypeChange(this.payMonthType);
        this.getAccountInfo();
    },
    watch: {
        curTab: {
            deep: true,
            immediate: true,
            handler(newVal) {
                // 订单记录与打款记录页面的分别曝光
                this.$wywLog.send({
                    serverId: 16260,
                    action: 'show',
                    area: newVal === 'orderRecord' ? 'ddjl_tab' : 'dkjl_tab'
                });
            }
        }
    },
    methods: {

        /**
         * tab切换
         * @param {String} data 选中tab的值
         */

        tabChange(data) {
            this.curTab = data.name;
            // 切换tab后页码改成1
            this.pageChange(1);
            this.$wywLog.send({
                serverId: 16260,
                action: 'click',
                area: this.curTab === 'orderRecord' ? 'ddjl_tab' : 'dkjl_tab'
            });
        },

        /**
         * 获取订单列表
         */

        getOrderList() {
            this.isTableLoading = true;
            let params = {
                startDate: this.startDate || '',
                endDate: this.endDate || '',
                pn: this.page,
                rn: this.pageSize
            };
            this.$http.get('law:/themis/law/income/getorder', {
                params
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.orderCount = res?.count || 0;
                this.orderList = res?.list || [];
            }).catch(err => {
                this.$normalizeResponseError(err);
            }).finally(() => {
                this.isTableLoading = false;
            });
        },

        /**
         * 获取打款列表
         */

        getPayList() {
            this.isTableLoading = true;
            let params = {
                startMonth: this.startMonth || '',
                endMonth: this.endMonth || '',
                pn: this.page,
                rn: this.pageSize
            };
            this.$http.get('law:/themis/law/income/getwithdraw', {
                params
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.payCount = res?.count || 0;
                this.payList = res?.list || [];
            }).catch(err => {
                this.$normalizeResponseError(err);
            }).finally(() => {
                this.isTableLoading = false;
            });
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.page = pn;
            if (this.curTab === 'orderRecord') {
                this.getOrderList();
                return;
            }
            this.getPayList();
        },

        /**
         * 日期范围选择组件的选中值改变
         */

        dateChange() {
            if (!this.dateRange.length) {
                return;
            }
            // 这里发现选中一次时间，会触发两次select事件
            // 自选时间范围存在
            let start = dayjs(this.dateRange[0]).format('YYYYMMDD');
            let end = dayjs(this.dateRange[1]).format('YYYYMMDD');
            // 自选时间范围和上一次请求时间一致，则不再请求
            if (start === this.startDate && end === this.endDate) {
                return;
            }
            this.startDate = start;
            this.endDate = end;
            this.getOrderList();
        },

        /**
         * 月份修改
         */

        monthChange() {
            if (!this.monthRange.length) {
                return;
            }
            // 自选月份范围存在
            let start = dayjs(this.monthRange[0]).format('YYYYMM');
            let end = dayjs(this.monthRange[1]).format('YYYYMM');
            // 自选月份范围和上一次请求一致，则不再请求
            if (start === this.startMonth && end === this.endMonth) {
                return;
            }
            this.startMonth = start;
            this.endMonth = end;
            this.getPayList();
        },

        /**
         * 筛选日期类型改变
         * @param {Number} day 日期类型：7,30,-1
         */

        dateTypeChange(day) {
            this.orderDateType = day || [];
            // 近5天、近7天
            if (this.orderDateType[0] > 0) {
                this.endDate = dayjs().format('YYYYMMDD');
                this.startDate = this.formatDate(this.orderDateType[0]);
                this.getOrderList();
                return;
            }
            // 自选时间范围
            // 自选时间范围不存在
            if (!this.dateRange || !this.dateRange.length) {
                return;
            }
            // 自选时间范围存在
            let start = dayjs(this.dateRange[0]).format('YYYYMMDD');
            let end = dayjs(this.dateRange[1]).format('YYYYMMDD');
            // 自选时间范围和上一次请求时间一致，则不再请求
            if (start === this.startDate && end === this.endDate) {
                return;
            }
            this.startDate = start;
            this.endDate = end;
            this.getOrderList();
        },

        /**
         * 筛选日期类型改变
         * @param {number} month 月份类型 3,6,-1
         */

        monthTypeChange(month) {
            this.payMonthType = month || [];
            // 选择近3个月、近6个月
            if (this.payMonthType[0] > 0) {
                this.endMonth = dayjs().format('YYYYMM');
                this.startMonth = this.formatDate(this.payMonthType[0], 'month');
                this.getPayList();
                return;
            }
            // 选择自选月份范围
            // 自选月份范围不存在
            if (!this.monthRange || !this.monthRange.length) {
                return;
            }
            // 自选月份范围存在
            let start = dayjs(this.monthRange[0]).format('YYYYMM');
            let end = dayjs(this.monthRange[1]).format('YYYYMM');
            // 自选月份范围和上一次请求一致，则不再请求
            if (start === this.startMonth && end === this.endMonth) {
                return;
            }
            this.startMonth = start;
            this.endMonth = end;
            this.getPayList();
        },

        /**
         * 获取账户信息
         */

        getAccountInfo() {
            this.$http.get('law:/themis/law/account/info', {}).then(resp => {
                const data = this.$normalizeResponseData(resp);
                if (data) {
                    this.isBindCard = !!data.card_num;
                    this.isShowBindCard = !data.card_num;
                    this.accountInfo = data;
                }
            }).catch(err => {
                this.$normalizeResponseError(err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        /**
         * 展示打款明细
         */

        showDetail(index) {
            this.detailInfo = this.payList[index] || {};
            this.isShowDetial = true;
        },

        /**
         * 格式化日期字段
         * @param {Number} day 类型 7:近七天、15:近15天
         * @param {String} type 类型 day：天 month：月
         */

        formatDate(day, type = 'day') {
            let now = dayjs();
            let date = now.subtract(day - 1, type);
            let str = type === 'day' ? 'YYYYMMDD' : 'YYYYMM';
            return date.format(str);
        },

        /**
         * 订单记录-导出
         */

        downloadOrder() {
            const params = {
                startDate: this.startDate,
                endDate: this.endDate,
                type: 0
            };
            this.$wywLog.send({
                serverId: 16260,
                action: 'click',
                area: 'dcddjl_btn'
            });
            downloadTool(params, 'law:/themis/law/income/exportorder', '');
        },

        /**
         * 打款记录-导出
         */

        downloadPay() {
            const params = {
                startMonth: this.startMonth,
                endMonth: this.endMonth
            };
            this.$wywLog.send({
                serverId: 16260,
                action: 'click',
                area: 'dcdkjl_btn'
            });
            downloadTool(params, 'law:/themis/law/income/exportwithdraw', '');
        },

        /**
         * 展示绑卡组件
         */

        showBindCard() {
            this.isShowBindCard = true;
            this.$wywLog.send({
                serverId: 16260,
                action: 'click',
                area: 'wdbkxx'
            });
        }
    }
};
</script>

<style lang='less' scoped>
.profit-center {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-sizing: border-box;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 24px 0;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000000;
            line-height: 18px;
            font-weight: 500;
        }

        .bind-card {
            font-size: 16px;
            color: #404EFF;
            line-height: 18px;
            cursor: pointer;
        }
    }

    .table-top {
        padding: 24px 0;
        display: flex;
        justify-content: flex-end;

        .export {
            cursor: pointer;
            display: flex;
            align-items: center;
            width: fit-content;

            .text {
                font-size: 16px;
                color: #404EFF;
                line-height: 16px;
            }

            .icon {
                height: 20px;
                width: 20px;
                margin-left: 4px;
                background: url(https://lvlin-base.cdn.bcebos.com/bend/profitCenter/export.png) no-repeat center center / 100%;
            }
        }
    }

    .table {
        .pagination {
            padding-top: 24px;
            float: right;
        }

        .text-btn {
            font-size: 16px;
            color: #404EFF;
            text-align: center;
            line-height: 16px;
        }
    }

    .tabs {
        position: relative;

        .date-wrap {
            position: absolute;
            right: 0;
            top: 0;
            height: 48px;
            display: flex;
            align-items: center;

            /deep/.veui-calendar {
                position: absolute;
                z-index: 1;
                right: 0;
            }

            /deep/.veui-radio {
                padding-left: 25px;
                margin-left: 0;
            }

            .date-select {
                border: 1px solid rgba(233,236,243,1);
                border-radius: 5px;
                height: 30px;
                width: 203px;
            }
        }
    }
}
/deep/.veui-radio input {
    position: relative;
    opacity: 0;
}
/deep/.veui-input-content {
    input {
        opacity: 1;
    }
}
/deep/.veui-date-picker-range {
    width: 260px;
}
/deep/.veui-table-no-data {
    height: 240px;
}
/deep/ .veui-field-content-wrap {
    min-height: 32px;
}
/deep/ .veui-radio-box-labelled {
    top: 0;
}
/deep/ .veui-radio {
    align-items: center;
}
</style>

<style lang='stylus' scoped>
    @import '../../../assets/css/law-table.styl';
</style>

<style lang='less'>
    .veui-overlay-box.syzx-date-picker {
        // left: -390px !important;
        top: 40px !important;
        width: 650px !important;
    }

    .veui-overlay-box.syzx-month-picker {
        left: -230px !important;
        top: 40px !important;
    }
</style>
